<template>
  <div>
    <a-form
      class="simiot-nested-search-form"
      :form="form"
      @submit="handleSearch"
    >
      <a-row :gutter="24">
        <a-col :xl="8" :xxl="6">
          <a-form-item label="划拨批次">
            <a-input
              v-decorator="['operation_no', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col v-if="isModuleAllocation" :xl="8" :xxl="6">
          <a-form-item label="模组厂商">
            <a-select
              v-decorator="['module_producer_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingProducerOptions"
              @change="handleProducerChange"
            >
              <a-select-option
                v-for="opt in producerOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-if="isCpeAllocation" :xl="8" :xxl="6">
          <a-form-item label="CPE供应商">
            <a-select
              v-decorator="['cpe_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingCpeSupplierOptions"
              @change="handleCpeSupplierChange"
            >
              <a-select-option
                v-for="opt in cpeSupplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-if="isCpeAllocation" :xl="8" :xxl="6">
          <a-form-item label="CPE型号">
            <a-select
              v-decorator="['cpe_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请先选择CPE供应商"
              :loading="loadingCpeModelOptions"
            >
              <a-select-option
                v-for="opt in cpeModelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ formatCpeModelOption(opt) }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-if="isEsimAllocation" :xl="8" :xxl="6">
          <a-form-item label="eSIM供应商">
            <a-select
              v-decorator="['esim_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingEsimSupplierOptions"
            >
              <a-select-option
                v-for="opt in esimSupplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-if="isProfileAllocation" :xl="8" :xxl="6">
          <a-form-item label="Profile供应商">
            <a-select
              v-decorator="['profile_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingProfileSupplierOptions"
            >
              <a-select-option
                v-for="opt in profileSupplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col v-if="isModuleAllocation" :xl="8" :xxl="6">
          <a-form-item label="模组型号">
            <a-select
              v-decorator="['module_model_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请先选择模组厂商"
              :loading="loadingModelOptions"
            >
              <a-select-option
                v-for="opt in modelOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="项目编号">
            <a-input
              v-decorator="['item_no', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="订单编号">
            <a-input
              v-decorator="['order_no', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="划拨人">
            <a-select
              show-search
              allow-clear
              option-filter-prop="children"
              :filter-option="filterOption"
              :loading="loadingOperatorOption"
              v-decorator="['operator_id']"
            >
              <a-select-option
                v-for="operator in operators"
                :key="operator.id"
                :value="operator.id"
              >
                {{ operator.full_name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6" v-show="expand">
          <a-form-item label="划拨时间">
            <a-range-picker v-decorator="['created_at']" />
          </a-form-item>
        </a-col>

        <a-col :xl="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
              <a-button :style="{ fontSize: '12px', lineHeight: '32px' }" @click="toggle">
                更多条件
                <a-icon :type="expand ? 'up' : 'down'" />
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { formatRangeBeginDate, formatRangeEndDate } from '@/utils/time'
import { findManageUserOptions } from '@/api/user'
import { findCommonTypeOptions } from '@/api/common_type'
import { findCpeSuppliers } from '@/api/cpe_supplier'
import { findCpeSupplierModelOptions } from '@/api/cpe_supplier_model'
import { findEsimSuppliers } from '@/api/esim_supplier'
import { findProfileSuppliers } from '@/api/profile_supplier'
export default {
  name: 'SearchAllocationRecord',
  props: {
    operationType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'allocation_record_search' }),
      expand: false,
      operators: [], // 划拨人
      loadingOperatorOption: false,
      producerOptions: [],
      modelOptions: [],
      loadingProducerOptions: false,
      loadingModelOptions: false,
      cpeSupplierOptions: [],
      cpeModelOptions: [],
      loadingCpeSupplierOptions: false,
      loadingCpeModelOptions: false,
      esimSupplierOptions: [],
      loadingEsimSupplierOptions: false,
      profileSupplierOptions: [],
      loadingProfileSupplierOptions: false
    }
  },
  computed: {
    isModuleAllocation() {
      return this.operationType === 'allocate_modules_to_top_agent'
    },
    isCpeAllocation() {
      return this.operationType === 'allocate_cpes_to_top_agent'
    },
    isEsimAllocation() {
      return this.operationType === 'allocate_esims_to_top_agent'
    },
    isProfileAllocation() {
      return this.operationType === 'allocate_profiles_to_top_agent'
    }
  },
  created() {
    this.fetchOperatorOptions()
    if (this.isModuleAllocation) {
      this.fetchProducerOptions()
    }
    if (this.isCpeAllocation) {
      this.fetchCpeSupplierOptions()
    }
    if (this.isEsimAllocation) {
      this.fetchEsimSupplierOptions()
    }
    if (this.isProfileAllocation) {
      this.fetchProfileSupplierOptions()
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand
    },

    // 加载划拨人
    fetchOperatorOptions() {
      this.loadingOperatorOption = true
      findManageUserOptions().then((res) => {
        if (res.code === 0) {
          this.operators = res.data
        }
        this.loadingOperatorOption = false
      })
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },

    fetchProducerOptions() {
      this.loadingProducerOptions = true
      findCommonTypeOptions('product_module_producer').then((res) => {
        if (res.code === 0) {
          this.producerOptions = res.data
        }
        this.loadingProducerOptions = false
      })
    },

    fetchModelOptions(producerId) {
      this.loadingModelOptions = true
      findCommonTypeOptions('product_module_model', undefined, producerId).then((res) => {
        if (res.code === 0) {
          this.modelOptions = res.data
        }
        this.loadingModelOptions = false
      })
    },

    handleProducerChange(producerId) {
      this.form.setFieldsValue({ module_model_id: undefined })
      if (!producerId) {
        this.modelOptions = []
        return
      }
      this.fetchModelOptions(producerId)
    },

    fetchCpeSupplierOptions() {
      this.loadingCpeSupplierOptions = true
      findCpeSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.cpeSupplierOptions = res.data
        }
        this.loadingCpeSupplierOptions = false
      })
    },

    fetchCpeModelOptions(supplierId) {
      this.loadingCpeModelOptions = true
      findCpeSupplierModelOptions({ cpe_supplier_id: supplierId }).then((res) => {
        if (res.code === 0) {
          this.cpeModelOptions = res.data
        }
        this.loadingCpeModelOptions = false
      })
    },

    formatCpeModelOption(opt) {
      if (opt.display_model && opt.display_model !== opt.purchase_model) {
        return `${opt.purchase_model}（对外：${opt.display_model}）`
      }
      return opt.purchase_model || opt.name
    },

    handleCpeSupplierChange(supplierId) {
      this.form.setFieldsValue({ cpe_model_id: undefined })
      if (!supplierId) {
        this.cpeModelOptions = []
        return
      }
      this.fetchCpeModelOptions(supplierId)
    },

    fetchEsimSupplierOptions() {
      this.loadingEsimSupplierOptions = true
      findEsimSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.esimSupplierOptions = res.data
        }
        this.loadingEsimSupplierOptions = false
      })
    },

    fetchProfileSupplierOptions() {
      this.loadingProfileSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) {
          this.profileSupplierOptions = res.data
        }
        this.loadingProfileSupplierOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      const fieldsValue = this.form.getFieldsValue()
      const values = {
        ...fieldsValue,
        created_at_begin: formatRangeBeginDate(fieldsValue.created_at),
        created_at_end: formatRangeEndDate(fieldsValue.created_at)
      }
      if (!values.module_producer_id) {
        delete values.module_producer_id
      }
      if (!values.module_model_id) {
        delete values.module_model_id
      }
      if (!values.cpe_supplier_id) {
        delete values.cpe_supplier_id
      }
      if (!values.cpe_model_id) {
        delete values.cpe_model_id
      }
      if (!values.esim_supplier_id) {
        delete values.esim_supplier_id
      }
      if (!values.profile_supplier_id) {
        delete values.profile_supplier_id
      }
      this.$emit('submit', values)
    },

    handleReset() {
      this.form.resetFields()
      this.modelOptions = []
      this.cpeModelOptions = []
      this.$emit('submit')
    }
  }
}
</script>
